export default __webpack_public_path__ + "static/rasgulla-2ec850af0af4d40bb818e9d670f7371b.png";